import { render } from "./RegleDeConfidentialite.vue?vue&type=template&id=7bbc6555&ts=true"
import script from "./RegleDeConfidentialite.vue?vue&type=script&lang=ts"
export * from "./RegleDeConfidentialite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__